import { allTrackers } from "app/services/track/track";

import createSuggestedQuickActionsTrackingService from "./factory";

const suggestedQuickActionsTrackingService = createSuggestedQuickActionsTrackingService(
    allTrackers.dispatchTrackEvent.bind(allTrackers),
);

export default suggestedQuickActionsTrackingService;
